import { render, staticRenderFns } from "./Ecpay.vue?vue&type=template&id=39932236&scoped=true&"
import script from "./Ecpay.vue?vue&type=script&lang=js&"
export * from "./Ecpay.vue?vue&type=script&lang=js&"
import style0 from "./Ecpay.vue?vue&type=style&index=0&id=39932236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39932236",
  null
  
)

export default component.exports